import { patchData } from 'api/services/mediaPlanning/utils';
import { CAMPAIGNv3 } from './mediaPlanning';

export interface StatusInfo {
  current: string;
  updatedBy: string;
  updatedAt: string;
}

export type Action = 'accept' | 'revert';

export interface AcceptUnlockPlanResult {
  statusInfo: StatusInfo;
  metaFinalBookingDate: string;
}

export const acceptUnlockMediaPlan = async (
  mediaPlanId: string | null,
  action: Action
) => {
  return patchData<AcceptUnlockPlanResult>(
    `/${CAMPAIGNv3}/media-plans/${mediaPlanId}/approval`,
    {
      action,
    }
  );
};
